export const AUDIENCE_TYPE_COMPLIANCE = 'compliance';

export const AUDIENCE_TYPES_MAP = {
    marketing: {
        name: 'marketing',
        label: 'Marketing',
        description: `<li> Contacts have <strong class="font-semibold">opted-in</strong> to <strong class="font-semibold">marketing</strong> messages.</li>
        <li> Message is for promotional content such as discounts, coupons, offers, etc.</li>
        <li> You should have <strong class="font-semibold">explicit permission</strong> to text these numbers or <strong class="font-semibold">risk service disruption</strong>.</li>`,
    },
    transactional: {
        name: 'transactional',
        label: 'Transactional',
        description: `<li> Message is for support or in response to an explicit request from customer. </li>
        <li> Message <strong class="font-semibold">cannot</strong> contain any type of promotional content or <strong class="font-semibold">risk service disruption.</strong></li>`,
    },
    acquisition: {
        name: 'acquisition',
        label: 'Acquisition',
        description: `<li> Contacts have not <strong class="font-semibold">opted-in</strong> or <strong class="font-semibold">opted-out</strong> yet. </li>
        <li> This is the first time you are messaging these contacts.</li>`,
    },
    re_acquisition: {
        name: 're_acquisition',
        label: 'Re-acquisition',
        description: `<li> Contacts have <strong class="font-semibold">opted-out</strong> of <strong class="font-semibold">marketing</strong> messages. </li>
                <li> Contacts should have done something to prompt reaching back out to them.</li>`,
    },
    // Messages carry one audience type beyond what campaigns offer: compliance,
    // reserved for consent management sends that no builder exposes yet.
    [AUDIENCE_TYPE_COMPLIANCE]: {
        name: AUDIENCE_TYPE_COMPLIANCE,
        label: 'Compliance',
        description: `<li> Message manages the contact's consent, such as an opt-in confirmation.</li>`,
    },
} as const;

export const audienceTypes = () => Object.values(AUDIENCE_TYPES_MAP);

export function audienceTypeLabel(audienceType: keyof typeof AUDIENCE_TYPES_MAP): string {
    return AUDIENCE_TYPES_MAP[audienceType]?.label || 'Unknown';
}
